export enum AnalyticRegionStateType {
  Original = 'Original',
  CurationRequired = 'CurationRequired',
  UnderCuration = 'UnderCuration',
  Curated = 'Curated',
  Approved = 'Approved',
  CurationBlocked = 'CurationBlocked'
}
